import { Box, Button, TextField, Typography } from '@mui/material'
import { sha256 } from 'js-sha256'
import { SubmitEvent, useState } from 'react'

export default function FormControls({ keyword, didSuccess }: { keyword: string; didSuccess: () => void }) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)

  const onSubmit = (e: SubmitEvent) => {
    e.preventDefault()
    setError(false)
    const trimmed = password.trim()
    const hash = sha256(trimmed).slice(0, 16)
    if (hash == keyword) {
      didSuccess()
      return
    }
    setError(true)
  }

  return (
    <Box sx={{ width: '100%', margin: ' 0 0 48px' }}>
      <Box
        component="form"
        sx={{
          margin: '0 0 16px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
        onSubmit={onSubmit}
      >
        <TextField
          type="password"
          sx={{
            flex: '1 1 100%',
            height: '54px',
            fontSize: '16px',
          }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          type="submit"
          disableElevation
          variant="contained"
          sx={{
            flex: '0 0 100px',
            height: '54px',
          }}
        >
          ENTER
        </Button>
      </Box>
      <Typography
        component="p"
        variant="body1"
        sx={{ textAlign: 'center', height: error ? '24px' : '0', transition: 'height 0.4s' }}
      >
        {error ? 'パスワードが一致しません。' : '　'}
      </Typography>
    </Box>
  )
}
